import React from 'react';
import moment from 'moment';
import '../App';

export const createTimeInput = dateStr =>
	dateStr === '' || dateStr === null || typeof dateStr === 'undefined' || dateStr === '0001-01-01T00:00:00'
		? ''
		: moment(dateStr).format('DD/MM/YYYY');

export const getExportDateTime = () => {
	let today = new Date();
	let dateTime =
		today.getDate() +
		'-' +
		(today.getMonth() + 1) +
		'-' +
		today.getFullYear() +
		'_' +
		today.getHours() +
		'-' +
		today.getMinutes() +
		'-' +
		today.getSeconds();
	return dateTime;
};

//_Fix of CSV file issue of skipping zero in specific Data which starts with Zero.
export const writeDataWithLeadingZeroInCsv = cell => {
	if (cell) return '\t' + cell;
	else return '';
};

export const replaceNullOrZeroWithEmptyString = cell => {
	if (cell && cell > 0) return cell;
	else return '';
};

export const amendmentReasonsFormat = cell => Object.keys(cell).length > 0 ? (
	<ul className="amendReasonList">
		{cell.map((item, index) => (
			<li style={{ fontWeight: '400' }} key={index}>
				{item}
			</li>
		))}
	</ul>) : '';
